export enum CollectionOrderBy {
  Custom = 'custom',
  Alphabetical = 'alphabetical',
  Randomized = 'randomized',
}
